$(document).ready(function () {
  function RankingSlider() {
    const breakpoint = 749;
    const slider = $('.shopify-section-slider');
    if (window.innerWidth > breakpoint) {
      if (slider.hasClass('slick-initialized')) {
        slider.slick('unslick');
      }
    } else {
      if (!slider.hasClass('slick-initialized')) {
        slider.slick({
          infinite: false,
          dots: true,
          centerMode: true,
          centerPadding: '50%',
          slidesToShow: 1.8,
          variableWidth: true,
          adaptiveHeight: true,
          autoplay: false,
          pauseOnHover: true,
        });
      }
    }
  }
  RankingSlider();
  $(window).on('resize', function () {
    RankingSlider();
  });
});

$(document).ready(function () {
  $('span.ranking_num').each(function () {
    const num = parseInt($(this).text()); // 数字を取得
    if (num === 1) {
      $(this).addClass('ranking_no1');
    } else if (num === 2) {
      $(this).addClass('ranking_no2');
    } else if (num === 3) {
      $(this).addClass('ranking_no3');
    } else {
      $(this).addClass('ranking_under3');
    }
  });
});
